import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { FaInstagram, FaFacebookF, FaTiktok, FaWhatsapp } from "react-icons/fa";
import "./footer.css";
import { useCookieConsent } from "../../context/CookieConsentContext";

const getDivisionFromPath = (pathname) => {
  if (pathname.startsWith("/men")) return "men";
  if (pathname.startsWith("/kids")) return "kids";
  if (pathname.startsWith("/sport")) return "sport";
  return "women";
};

const scrollToTop = () => window.scrollTo(0, 0);

export default function Footer() {
  const location = useLocation();
  const { openSettings } = useCookieConsent();
  const division = getDivisionFromPath(location.pathname);

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Brand */}
          <div className="footer-brand-col">
            <Link to="/" className="footer-logo" onClick={scrollToTop}>
              ninetyone
            </Link>
            <p className="footer-tagline">
              Streetwear and modern fashion in Kenya. Shop trending hoodies,
              tees, jackets and everyday styles, delivered in Nairobi and across
              Kenya.
            </p>
            <div className="footer-socials">
              <a href="#" className="footer-social-link" aria-label="Instagram">
                <FaInstagram className="footer-icon" />
              </a>
              <a href="#" className="footer-social-link" aria-label="TikTok">
                <FaTiktok className="footer-icon" />
              </a>
              <a href="#" className="footer-social-link" aria-label="Facebook">
                <FaFacebookF className="footer-icon" />
              </a>
              <a href="#" className="footer-social-link" aria-label="WhatsApp">
                <FaWhatsapp className="footer-icon" />
              </a>
            </div>
            <div className="footer-contact-list">
              <div className="footer-contact-item">
                <Phone size={16} /> <span>+254 726 327 352</span>
              </div>
              <div className="footer-contact-item">
                <Mail size={16} /> <span>support@ninetyone.co.ke</span>
              </div>
              <div className="footer-contact-item">
                <MapPin size={16} /> <span>Nairobi, Kenya</span>
              </div>
            </div>
          </div>

          {/* Shop */}
          <div className="footer-col">
            <h4 className="footer-heading">Shop</h4>
            <ul className="footer-list">
              <li>
                <Link
                  to={`/all-products?division=${division}`}
                  state={{ tag: "new" }}
                  className="footer-link"
                  onClick={scrollToTop}
                >
                  New Arrivals
                </Link>
              </li>
              <li>
                <Link
                  to={`/all-products?division=${division}`}
                  state={{ tag: "bestseller" }}
                  className="footer-link"
                  onClick={scrollToTop}
                >
                  Best Sellers
                </Link>
              </li>
              <li>
                <Link
                  to="/all-products?division=women"
                  className="footer-link"
                  onClick={scrollToTop}
                >
                  Women
                </Link>
              </li>
              <li>
                <Link
                  to="/all-products?division=men"
                  className="footer-link"
                  onClick={scrollToTop}
                >
                  Men
                </Link>
              </li>
              <li>
                <Link
                  to={`/all-products?division=${division}`}
                  state={{ categoryId: "6a8a1df9c007e62c2b795293" }}
                  className="footer-link"
                  onClick={scrollToTop}
                >
                  Accessories
                </Link>
              </li>
              <li>
                <Link
                  to={`/all-products?division=${division}`}
                  state={{ tag: "sale" }}
                  className="footer-link"
                  onClick={scrollToTop}
                >
                  Sale
                </Link>
              </li>
            </ul>
          </div>

          {/* Help */}
          <div className="footer-col">
            <h4 className="footer-heading">Help</h4>
            <ul className="footer-list">
              <li>
                <Link
                  to="/shipping"
                  className="footer-link"
                  onClick={scrollToTop}
                >
                  Shipping & Delivery
                </Link>
              </li>
              <li>
                <Link
                  to="/return-policy"
                  className="footer-link"
                  onClick={scrollToTop}
                >
                  Returns
                </Link>
              </li>
              <li>
                <Link
                  to="/trackorder"
                  className="footer-link"
                  onClick={scrollToTop}
                >
                  Track Order
                </Link>
              </li>
              <li>
                <Link to="/faqs" className="footer-link" onClick={scrollToTop}>
                  FAQs
                </Link>
              </li>
            </ul>
          </div>

          {/* About */}
          <div className="footer-col">
            <h4 className="footer-heading">About</h4>
            <ul className="footer-list">
              <li>
                <Link
                  to="/our-story"
                  className="footer-link"
                  onClick={scrollToTop}
                >
                  Our Story
                </Link>
              </li>
              <li>
                <Link
                  to="/contact-us"
                  className="footer-link"
                  onClick={scrollToTop}
                >
                  Contact Us
                </Link>
              </li>
              <li>
                <Link
                  to="/store-locator"
                  className="footer-link"
                  onClick={scrollToTop}
                >
                  Store Locator
                </Link>
              </li>
            </ul>
          </div>

          {/* Bottom bar */}
          <div className="footer-bottom">
            <div className="footer-bottom-spacer" aria-hidden="true"></div>

            <p className="footer-copyright">
              © {new Date().getFullYear()} ninetyone. All rights reserved.
            </p>

            <div className="footer-bottom-links">
              <Link
                to="/policy"
                className="footer-bottom-link"
                onClick={scrollToTop}
              >
                Privacy Policy
              </Link>

              <Link
                to="/terms"
                className="footer-bottom-link"
                onClick={scrollToTop}
              >
                Terms & Conditions
              </Link>

              <button
                type="button"
                onClick={openSettings}
                className="footer-bottom-link footer-cookie-button"
              >
                Cookie Preferences
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
